module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payroll-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Payroll')))])])]), (_vm.forbidden) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('payroll.message.forbidden')))])])])]) : _vm._e(), (_vm.notify) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert",
    class: _vm.notify.danger ? 'alert-danger' : 'alert-success'
  }, [_c('span', [_vm._v(_vm._s(_vm.notify.message))])])])]) : _vm._e(), (!_vm.forbidden) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel panel-default payroll-import"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    on: {
      "click": _vm.toggleImport
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.importOpen ? 'fa-caret-down' : 'fa-caret-right'
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('payroll.label.import_panel')))])]), _c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": _vm.toggleImport
    }
  }, [_vm._v(_vm._s(_vm.importOpen ? _vm.$t('payroll.button.close_import') : _vm.$t('payroll.button.open_import')))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importOpen),
      expression: "importOpen"
    }],
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.document_type')))]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importDocumentType),
      expression: "importDocumentType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.importDocumentType = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "salary"
    }
  }, [_vm._v(_vm._s(_vm.$t('payroll.document_type.salary')))]), _c('option', {
    attrs: {
      "value": "bonus"
    }
  }, [_vm._v(_vm._s(_vm.$t('payroll.document_type.bonus')))])])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.pay_date')))]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importPayDate),
      expression: "importPayDate"
    }],
    attrs: {
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.importPayDate)
    },
    on: {
      "input": function($event) {
        _vm.importPayDate = $event
      }
    }
  })], 1)]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.file')))]), _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.inputClear) ? _c('input', {
    attrs: {
      "type": "file",
      "accept": ".xlsx"
    },
    on: {
      "change": _vm.onFileChange
    }
  }) : _vm._e(), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('payroll.message.file_help')))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-8"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    class: (!_vm.importFile || !_vm.importPayDateValue || _vm.importing) ? 'disabled' : '',
    on: {
      "click": _vm.submitImport
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.importing ? _vm.$t('payroll.button.importing') : _vm.$t('payroll.button.import')))])])])])])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "well well-sm payroll-format"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('payroll.label.format')))])]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('payroll.format.sheet')))]), _c('li', [_vm._v(_vm._s(_vm.$t('payroll.format.required')))]), _c('li', [_vm._v(_vm._s(_vm.$t('payroll.format.login_id')))]), _c('li', [_vm._v(_vm._s(_vm.$t('payroll.format.columns')))]), _c('li', [_vm._v(_vm._s(_vm.$t('payroll.format.upsert')))]), _c('li', [_vm._v(_vm._s(_vm.$t('payroll.format.excluded')))])]), _c('a', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "href": _vm.sampleUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('payroll.label.sample')))])])])])]), (_vm.importResult) ? _c('div', {
    staticClass: "import-result"
  }, [_c('hr'), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('payroll.label.result')))])]), _c('p', [_vm._v(_vm._s(_vm.$t('payroll.label.imported')) + "：" + _vm._s(_vm.importResult.imported) + "　" + _vm._s(_vm.$t('payroll.label.updated')) + "：" + _vm._s(_vm.importResult.updated))]), (_vm.importResult.skipped_count > 0) ? _c('div', [_c('p', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.skipped')) + "：" + _vm._s(_vm.importResult.skipped_count))]), _c('ul', _vm._l((_vm.importResult.skipped_login_ids), function(loginId) {
    return _c('li', [_vm._v(_vm._s(loginId))])
  }))]) : _vm._e(), (_vm.importResult.pdf_failed_count > 0) ? _c('div', [_c('p', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.pdf_failed')) + "：" + _vm._s(_vm.importResult.pdf_failed_count))]), _c('ul', _vm._l((_vm.importResult.pdf_failed_login_ids), function(loginId) {
    return _c('li', [_vm._v(_vm._s(loginId))])
  }))]) : _vm._e(), (_vm.importResult.error_rows && _vm.importResult.error_rows.length > 0) ? _c('div', [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.error_rows')) + "：" + _vm._s(_vm.importResult.error_rows.length))]), _c('ul', _vm._l((_vm.importResult.error_rows), function(errorRow) {
    return _c('li', [_vm._v(_vm._s(errorRow.row) + "行目　" + _vm._s(errorRow.login_id) + "　" + _vm._s(errorRow.message))])
  }))]) : _vm._e()]) : _vm._e()])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.login_id')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginId),
      expression: "loginId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.loginId)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.search()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginId = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.pay_date')))]), _c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payDate),
      expression: "payDate"
    }],
    attrs: {
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.payDate)
    },
    on: {
      "input": function($event) {
        _vm.payDate = $event
      }
    }
  })], 1)]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.document_type')))]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.documentType = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('payroll.document_type.all')))]), _c('option', {
    attrs: {
      "value": "salary"
    }
  }, [_vm._v(_vm._s(_vm.$t('payroll.document_type.salary')))]), _c('option', {
    attrs: {
      "value": "bonus"
    }
  }, [_vm._v(_vm._s(_vm.$t('payroll.document_type.bonus')))])])])]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" ")]), _c('div', [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Search')))])])])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [((_vm.documents != null && _vm.documents.length > 0) && _vm.searchCallbackFlag) ? _c('div', [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.login_id')))]), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.user_name')))]), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.document_type')))]), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.$t('payroll.label.pay_date')))]), _c('th', {
    staticClass: "col-sm-2"
  })])]), _c('tbody', _vm._l((_vm.documents), function(document, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(document.attributes['login-id']))]), _c('td', [_vm._v(_vm._s(document.attributes['user-name']) + "　" + _vm._s(document.attributes['user-firstname']))]), _c('td', [_vm._v(_vm._s(document.attributes['document-type-i18n']))]), _c('td', [_vm._v(_vm._s(document.attributes['pay-date-format']))]), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "btn btn-sm btn-primary",
      on: {
        "click": function($event) {
          _vm.showDetail(document.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('payroll.button.show')))])])])])
  }))])]) : _vm._e(), ((_vm.documents == null || _vm.documents.length <= 0) && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])]) : _vm._e()]), (_vm.document) ? _c('div', {
    staticClass: "row margin-top payroll-detail"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.document.attributes['user-name']) + " " + _vm._s(_vm.document.attributes['user-firstname']) + "　\n" + _vm._s(_vm.document.attributes['document-type-i18n']) + "　" + _vm._s(_vm.document.attributes['pay-date-format'])), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.document.attributes['pdf-available']) ? _c('a', {
    staticClass: "btn btn-xs btn-primary",
    on: {
      "click": _vm.downloadPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('payroll.button.download')))])]) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('payroll.message.pdf_not_ready')))])])]), _c('table', {
    staticClass: "table table-condensed"
  }, [(_vm.document.attributes['sections']) ? _c('tbody', [_vm._l((_vm.document.attributes['sections']), function(section) {
    return [_c('tr', {
      staticClass: "active payroll-section"
    }, [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(section.label))])]), _vm._l((section.rows), function(row) {
      return _c('tr', [_c('th', {
        staticClass: "col-sm-4"
      }, [_vm._v(_vm._s(row.label))]), _c('td', {
        class: _vm.isAmountRow(row) ? 'text-right' : ''
      }, [_vm._v(_vm._s(_vm.formatValue(row)))])])
    })]
  })], 2) : _c('tbody', _vm._l((_vm.document.attributes['rows']), function(row) {
    return _c('tr', [_c('th', {
      staticClass: "col-sm-4"
    }, [_vm._v(_vm._s(row.label))]), _c('td', {
      class: _vm.isAmountRow(row) ? 'text-right' : ''
    }, [_vm._v(_vm._s(_vm.formatValue(row)))])])
  }))])])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0c91706!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/payroll-list.pug
// module id = 918
// module chunks = 1